import { Invitation } from '@qaroni-app/invitations/types/invitation';
import { QaroniCache } from '@qaroni-core/types/qaroni-cache/qaroni-cache';

export class InvitationCache extends QaroniCache<Invitation> {
  public canReturn(companyID: number, employeeID: number): boolean {
    return this.get() &&
      Number.isInteger(companyID) &&
      Number.isInteger(employeeID) &&
      this.get().companyId === companyID &&
      this.get().employeeId === employeeID
      ? true
      : false;
  }

  public canApi(companyID: number, employeeID: number): boolean {
    return !this.canReturn(companyID, employeeID) && !this.flying
      ? true
      : false;
  }
}
